export default ({ assetsDirectory }) => ({
  type: 'function',
  processor: 'mustache',
  provider: () => `
<div>
  <!-- Description -->
  <p>{{PROVIDER_SUBTITLE_FILESYSTEM_ID}}</p>

  <!-- Button to open the good and bad example -->
  <div class="full-width bdr-a-application-primary q-pa-sm row items-center q-mt-md rounded-borders cursor-pointer" data-jcs-element="preview__page__open__info__id">
    <img class="preview-info-icon" src="${assetsDirectory}/images/info-icon.svg" />
    <span class="preview-info-main-text">{{PREVIEW_INFO_TITLE_ID}}</span>
  </div>
  
  <!-- UI for good and bad examples -->
  <div class="preview-info-inner-container" data-jcs-element="preview__info__container__id">
    <div class="row justify-between items-center full-width">
      <p class="text-primary text-weight-medium">{{PREVIEW_INFO_TITLE_ID}}</p>
      <i class="cursor-pointer eva eva-close-circle-outline text-grey-8 text-h5" data-jcs-element="preview__page__close__info__id"></i>
    </div>
    <div>
      <div class="row q-gutter-x-sm q-pt-md q-mb-sm">
        <div class="col id-example-good">
          <img class="sample-image sample-image-success" src="${assetsDirectory}/images/licence-good.svg" />
          <div class="separating-rectangle q-mb-xs bg-positive"></div>
          <div class="text-positive row items-center q-gutter-x-xs">
            <img src="${assetsDirectory}/images/green-check-icon.svg" />
            <span>{{PREVIEW_INFO_GOOD}}</span>
          </div>
          <span class="text-tab">{{PREVIEW_INFO_GOOD_EXAMPLE_ID}}</span>
        </div>
        <div class="col id-example-angle-check">
          <img class="sample-image sample-image-error"
            src="${assetsDirectory}/images/licence-bad-angle.svg" />
          <div class="separating-rectangle q-mb-xs bg-negative"></div>
          <div class="text-negative row items-center q-gutter-x-xs">
            <img src="${assetsDirectory}/images/red-x-icon.svg" />
            <span>{{PREVIEW_INFO_BAD}}</span>
          </div>
          <span class="text-tab">{{PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ID}}</span>
        </div>
      </div>
      <div class="row q-gutter-x-sm q-pt-md">
        <div class="col id-example-cover-check">
          <img class="sample-image sample-image-error"
            src="${assetsDirectory}/images/licence-bad-covered.svg" />
          <div class="separating-rectangle q-mb-xs bg-negative"></div>
          <div class="text-negative row items-center q-gutter-x-xs">
            <img src="${assetsDirectory}/images/red-x-icon.svg" />
            <span>{{PREVIEW_INFO_BAD}}</span>
          </div>
          <span class="text-tab">{{PREVIEW_INFO_BAD_EXAMPLE_COVER_ID}}</span>
        </div>
        <div class="col id-example-blur-check">
          <img class="sample-image sample-image-error"
            src="${assetsDirectory}/images/licence-bad-blurred.svg" />
          <div class="separating-rectangle q-mb-xs bg-negative"></div>
          <div class="text-negative row items-center q-gutter-x-xs">
            <img src="${assetsDirectory}/images/red-x-icon.svg" />
            <span>{{PREVIEW_INFO_BAD}}</span>
          </div>
          <span class="text-tab">{{PREVIEW_INFO_BAD_EXAMPLE_BLUR_ID}}</span>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Section Header -->
  <p class="text-weight-bold q-mt-lg">
    <span data-jcs-element="info__journey__action" class="info-item__value">...</span>
  </p>

  <!-- Message for File type and size -->
  <div class="q-my-sm">
    <p class="text-grey-6 text-tab">{{FILESYSTEM_SUPPORTED_TYPES_START}}<i>{{FILESYSTEM_SUPPORTED_TYPES_END}}</i></p>
    <p class="text-grey-6 text-tab">{{FILESYSTEM_MAX_FILE_SIZE}}</p>
  </div>



  <!-- Image preview -->
  <div class="file-upload-container bdr-a-primary bdr-dashed bg-primary-pale rounded-borders-lg column items-center justify-center q-pa-sm relative-position">
    <img data-jcs-element="view__preview" class="image-preview">
    <div data-jcs-element="overlay_viewfinder" class="camera-viewfinder--overlay--transparent">
      <div class="loading-animation-container" data-jcs-element="loading-animation">
      </div>
    </div>
  </div>

  <!-- Actions to retry or upload -->
  <div class="q-mt-sm">
    <button class="button text-weight-medium button--retry full-width q-mb-sm" data-jcs-element="view__retry"
    aria-label="{{VIEW_RETRY}}">
      {{VIEW_RETRY}}
    </button>
    <button class="button text-weight-medium text-white bg-primary button-rounded full-width q-mt-lg" data-jcs-element="view__upload"
      aria-label="{{VIEW_UPLOAD}}">
      {{VIEW_UPLOAD}}
    </button>
  </div>

  <!-- Status Message -->
  <div data-jcs-element="view__status">
    <p data-jcs-element="view__status__message"></p>
  </div>
</div>
  `
});
